import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'redux/store';
import { ThemesType } from 'styles';

export const themesSelector = (state: RootState) => state.theme;

export const themeSelector = createSelector(themesSelector, (state: ThemesType) => state);
